//-- Copyright (c) 2021 TMT Insights Group, LLC
import { JobDetail } from '@/redux/slices/slice_types';
import { JobDetails, TitleBar } from '@/__configs/config_types';
import { LinkButton } from '@tmt-insights/oms_fe_core/columns';

const jobDetails: JobDetails = {
  titleBar: (): TitleBar[] => [
    {
      key: 'rally_id',
      label: 'Rally ID',
      render: (data: JobDetail) => {
        return data?.primary_rally_url ? (
          <LinkButton onClick={() => window.open(data?.primary_rally_url, '_blank')}>{data?.version?.rally_id ?? data?.primary_rally_url?.split('/').pop()}</LinkButton>
        ) : (
          data?.version?.rally_id || '-'
        );
      }
    },
    {
      key: 'program_id',
      label: 'Program ID',
      render: (data: JobDetail) => data.version?.program_id
    },
    {
      key: 'piece_id',
      label: 'Piece ID',
      render: (data: JobDetail) => data.version?.piece_id
    },
    {
      key: 'piece_number',
      label: 'Piece Number',
      render: (data: JobDetail) => data.version?.piece_number
    },
    {
      key: 'broadcast_length',
      label: 'Broadcast Length'
    }
  ]
};

export default jobDetails;
